import t from "../common/localization";
import React from "react";
import { useSelector } from "react-redux";
import { useAttributePreference } from "../common/preferences";
import {
  formatDistance,
  formatHours,
  formatDate,
  formatSpeed,
  formatVolume,
  formatPosition,
  formatDurationTime,
} from "../common/formatter";
import FaceIcon from "@material-ui/icons/Face";
import FavoriteIcon from "@material-ui/icons/Favorite";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import Divider from "@material-ui/core/Divider";
import SpeedIcon from "@material-ui/icons/Speed";
import Chip from "@material-ui/core/Chip";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import BatteryStdIcon from "@material-ui/icons/BatteryStd";
import NavigationIcon from "@material-ui/icons/Navigation";
import AcUnitIcon from "@material-ui/icons/AcUnit";
import LocalGasStationIcon from "@material-ui/icons/LocalGasStation";
import { Grid, Paper, List, ListItem } from "@material-ui/core";
import { isWidthUp, makeStyles, withWidth } from "@material-ui/core";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import LockIcon from '@material-ui/icons/Lock';
import Fab from '@material-ui/core/Fab';
import Avatar from "@material-ui/core/Avatar";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    borderRadius: 15,
    // backgroundColor: "#F1F3F6",
    fontSize: 12,
    width: "300px"
  },
  row: {
    height: "auto",
  },
  list: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  listItem: {
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  value: {
    margin: "0",
        textAlign: "center",
        fontSize: "12px",
        color: "#1F1F51",
  },
  colP: {
    margin: "0",
        textAlign: "center",
        fontSize: "9px",

  },
   statusGridOn: {
      backgroundColor: "#C5E2C9",
      color: "green",
      borderRadius: "25px",
      paddingLeft: "7px",
      margin: theme.spacing(0.5),
    },
    statusGridOff: {
      backgroundColor: "#FFE9D1",
      color: "#ce5934",
      borderRadius: "25px",
      paddingLeft: "7px",
      margin: theme.spacing(0.5),
    },
    fabButtonsSecond: {
        maxHeight: "24px",
        minHeight: "24px",
        minWidth: "24px",
        maxWidth: "24px",
        fontSize: "1rem",
        backgroundColor: "#3F51B2",
    },
  chip: {
        margin: theme.spacing(0.5),
    }
}));

const StatusView = ({ deviceId, onShowDetails, markerData }) => {
  const device = useSelector((state) => state.devices.items[deviceId]);
  const devicePosition = useSelector((state) => state.positions.items[deviceId]);
  const position = markerData || devicePosition;

  const distanceUnit = useAttributePreference("distanceUnit");
  const speedUnit = useAttributePreference("speedUnit");
  const volumeUnit = useAttributePreference("volumeUnit");

  const handleClick = (e) => {
    e.preventDefault();
    onShowDetails(position.id);
  };
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={1} justify="space-around" alignItems="center">
        <Grid item xs={7}>
        <ListItemAvatar style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingTop: '5px',
                        }}>
        <Avatar className={classes.fabButtonsSecond}>
        <DriveEtaIcon style={{width:'16px', height:'16px'}}/>
        </Avatar>
        <b style={{marginLeft:'5px'}}>{(device && device.name) || position.name}</b>
        </ListItemAvatar>
        </Grid>
        <Grid item xs={5}>
         <Chip
        label={<b>{formatDate(position.serverTime, "MMM D, hh:mm A")}</b>}
        icon={<AccessTimeIcon/>}
         className={classes.chip}
         size="small"
         color="secondary"
         style={{
               backgroundColor: "#E7F4DE",
               color: "green",
               borderRadius: 3,
               marginLeft: "-20px",
               marginTop: "10px"
               }}
               />
        </Grid>
        </Grid>
        <Grid container spacing={1} direction="row" justify="space-evenly" alignItems="center">
        <Grid item xs={1}>
        { <LocationOnIcon style={{ color: "#0C9F95", fontSize: "18", alignItems: "right" }}/>}
        </Grid>
           <Grid item xs={11}>
           <marquee> <b>{position.address || "No Data"}</b></marquee>
        </Grid>
        </Grid>
        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Grid container spacing={0}>
              <Grid item xs={4} alignItems="center">
                {/* <Paper className={classes.paper}> */}
                <p className={classes.colP}>
                  {<SpeedIcon style={{ color: "#6C6C6C", fontSize: "18", position: "center", horizontalAlign: "middle" }} />}
                </p>
                <p
                  className={classes.value}>
                  <b>{formatSpeed(position.speed, speedUnit)}</b>
                </p>
                <p className={classes.colP}>
                  {t("positionSpeed")}
                </p>
              </Grid>
              <Grid item xs={4}>
                <p className={classes.colP}>
                  {
                    <NavigationIcon style={{ color: "#853AE5", fontSize: "20" }}/>
                  }
                </p>
                <p className={classes.value}>
                 <b>{formatDistance(position?.attributes?.todayDistance,distanceUnit)}</b>
                </p>
                <p className={classes.colP}>
                  {t("distance")}
                </p>
              </Grid>
              <Grid item xs={4}>
                <p className={classes.colP}>
                  {
                    <BatteryStdIcon
                      style={{ color: "#00D3A5", fontSize: "20" }}
                    />
                  }
                </p>
                <p className={classes.value}>
                  <b>{formatPosition(position?.attributes?.batteryLevel,"batteryLevel")}</b>
                </p>
                <p className={classes.colP}>
                  {t("positionBattery")}
                </p>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Grid container spacing={0}>

              <Grid item xs={4}>

                <p className={classes.value}>
                  <b>{formatDistance(position?.attributes?.totalDistance,distanceUnit)}</b>
                </p>
                <p className={classes.colP}>
                  {t("deviceTotalDistance")}
                </p>
              </Grid>

              {Object.keys(position.attributes).indexOf('todayFuel')>-1 &&
            <Grid item xs={4}>
                <p className={classes.value}>
                  <b>{formatVolume(position.attributes.todayFuel, "40")}</b>
                </p>
                <p className={classes.colP}>
                  {t("todayFuel")}
                </p>
              </Grid>
              }
               <Grid item xs={4}>
                              <p className={classes.value}>
                               <b> {formatDistance(position.attributes.distanceFromLastStop,distanceUnit)}</b>
                              </p>
                              <p className={classes.colP}>
                                {t("distanceFromLastStop")}
                              </p>
                            </Grid>
            </Grid>
          </ListItem>

          <ListItem className={classes.listItem}>
            <Grid container spacing={0}>
              <Grid item xs={4}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.value}
                  >
                  <b>{formatDurationTime(position.attributes.todayRunningTime)}</b>
                </p>
                <p className={classes.colP}>
                  {t("todayRunningTime")}
                </p>
              </Grid>
              <Grid item xs={4}>

                <p className={classes.value}>
                  <b>{formatDurationTime(position.attributes.todayStoppedTime)}</b>
                </p>
                <p className={classes.colP}>
                  {t("todayStoppedTime")}
                </p>
              </Grid>
              <Grid item xs={4}>
                <p className={classes.value}>
                   <b>{formatDurationTime(position.attributes.todayIdleTime)}</b>
                </p>
                <p className={classes.colP}>
                 {t("todayIdleTime")}
                </p>
              </Grid>
            </Grid>
          </ListItem>

          <ListItem className={classes.listItem}>
            <Grid container spacing={0}>
              <Grid item xs={4}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.value}
                  >
                  <b>{formatPosition(position.attributes.currentStatus,"currentStatus")}</b>
                </p>
                <p className={classes.colP}>
                  {t("currentStatus")}
                </p>
              </Grid>
              <Grid item xs={4}>

                <p className={classes.value}>
                  <b>{formatSpeed(position.attributes.todayMaxSpeed, speedUnit)}</b>
                </p>
                <p className={classes.colP}>
                  {t("todayMaxSpeed")}
                </p>
              </Grid>

            </Grid>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Grid container spacing={0}>
              <Grid item xs={4}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.value}
                  >
                  <b>{formatDurationTime(position.attributes.todayIgnitionOnTime)}</b>
                </p>
                <p className={classes.colP}>
                  {t("todayIgnitionOnTime")}
                </p>
              </Grid>
              <Grid item xs={4}>

                <p className={classes.value}>
                 <b> {formatDurationTime(position.attributes.todayIgnitionOffTime)}</b>
                </p>
                <p className={classes.colP}>
                  {t("todayIgnitionOffTime")}
                </p>
              </Grid>
              <Grid item xs={4}>

                <p className={classes.value}>
                  <b> {formatDurationTime((position.attributes.ignitionOnSince> 0 ? position.attributes.ignitionOnSince : position.attributes.ignitionOffSince))}</b>
                </p>
                <p className={classes.colP}>
                 {t((position.attributes.ignitionOnSince> 0 ? 'ignitionOnSince' : 'ignitionOffSince'))}
                </p>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Grid container spacing={0}>
              <Grid item xs={4}>
                {/* <Paper className={classes.paper}> */}

                <p
                  className={classes.value}

                >
                 <b> {formatDurationTime(position.attributes.todayAcOnTime)}</b>
                </p>
                <p className={classes.colP}>
                  {t("todayAcOnTime")}
                </p>
              </Grid>
              <Grid item xs={4}>

                <p className={classes.value}>
                  <b> {formatDurationTime(position.attributes.todayAcOffTime)}</b>
                </p>
                <p className={classes.colP}>
                 {t("todayAcOffTime")}
                </p>
              </Grid>
              <Grid item xs={4}>
                <p className={classes.value}>
               <b>{formatDurationTime((position.attributes.acOnSince> 0 ? position.attributes.acOnSince : position.attributes.acOffSince))}</b>
                </p>
                <p className={classes.colP}>
                                 {t((position.attributes.acOnSince> 0 ? 'acOnSince' : 'acOffSince'))}
                </p>
              </Grid>
            </Grid>
          </ListItem>

          <ListItem className={classes.listItem}>
            <Grid container spacing={0}>
              {
                position.attributes.todayMileageConsumedFuel && (<Grid item xs={4}>
                  {/* <Paper className={classes.paper}> */}
  
                  <p
                    className={classes.value}>
                   <b>{formatVolume(position.attributes.todayMileageConsumedFuel)}</b>
                  </p>
                  <p className={classes.colP}>
                    {t("todayMileageConsumedFuel")}
                  </p>
                </Grid>)
              }
              {Object.keys(position.attributes).indexOf('totalMileageConsumedFuel')>-1 &&
                <Grid item xs={4}>

                <p className={classes.value}>
                  <b>{formatVolume(position.attributes.totalMileageConsumedFuel)}</b>
                </p>
                <p className={classes.colP}>
                  {t("totalMileageConsumedFuel")}
                </p>
              </Grid>
               }

              <Grid item xs={4}>
                <p className={classes.value}>
                  <b>{formatPosition(position.attributes.mtCustom1, "mtCustom1")}</b>
                </p>
                <p className={classes.colP}>
                  {t("mtCustom1")}
                </p>
              </Grid>
            </Grid>
            </ListItem>

            <ListItem className={classes.listItem}>
            <Grid container spacing={0} justify="center">
            <Grid item xs={2.5}>
            {position.attributes.ignition != "undefined" && (
                        <Chip
                          label={position.attributes.ignition}
                          icon={<VpnKeyIcon />}
                          className={
                            position.attributes.ignition
                              ? classes.statusGridOn
                              : classes.statusGridOff
                          }
                          size="small"
                          color="secondary"
                        />
                      )}
                      </Grid>
            <Grid item xs={2.5}>
                      {position.attributes.charge != "undefined" && (
                        <Chip
                          label={position.attributes.charge}
                          icon={<BatteryStdIcon />}
                          size="small"
                          color="secondary"
                          className={
                            position.attributes.charge ? classes.statusGridOn : classes.statusGridOff
                          }
                        />
                      )}
                      </Grid>
            <Grid item xs={2.5}>
                      {position.attributes.ac != "undefined" && (
                        <Chip
                          label={position.attributes.ac}
                          icon={<AcUnitIcon />}
                          size="small"
                          color="secondary"
                          className={
                            position.attributes.ac ? classes.statusGridOn : classes.statusGridOff
                          }
                        />
                      )}
                      </Grid>
            <Grid item xs={2.5}>
                      {position.attributes.door != "undefined" && (
                        <Chip
                          label={position.attributes.door}
                          icon={<MeetingRoomIcon />}
                          size="small"
                          color="secondary"
                          className={
                            position.attributes.door ? classes.statusGridOn : classes.statusGridOff
                          }
                        />
                      )}
                      </Grid>
           <Grid item xs={2.5}>
                      {position.attributes.blocked != "undefined" && (
                        <Chip
                          label={position.attributes.blocked}
                          icon={<LockIcon />}
                          size="small"
                          color="secondary"
                          className={
                            position.attributes.blocked ? classes.statusGridOn : classes.statusGridOff
                          }
                        />
                      )}
                      </Grid>
                      </Grid>
          </ListItem>
        </List>
        {position.attributes.todayMileageConsumedFuel && (
          <>
            <b>{t("todayMileageConsumedFuel")}:</b>{" "}
            {formatVolume(position.attributes.todayMileageConsumedFuel)}
            <br />
          </>
        )}
        {position.attributes.totalMileageConsumedFuel && (
          <>
            <b>{t("totalMileageConsumedFuel")}:</b>{" "}
            {formatVolume(position.attributes.totalMileageConsumedFuel)}
            <br />
          </>
        )}
      </div>
    </>
  );
};

export default StatusView;
